"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Hook;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _webhookHelpers = require("src/helpers/webhookHelpers");
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _Filter = /*#__PURE__*/ _interop_require_default(require("~/models/Filter"));
const _HookFilter = /*#__PURE__*/ _interop_require_default(require("~/models/HookFilter"));
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Hook = class Hook {
    static async get(context, hookId, ncMeta = _Noco.default.ncMeta) {
        let hook = hookId && await _NocoCache.default.get(context, `${_globals.CacheScope.HOOK}:${hookId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!hook) {
            hook = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.HOOKS, hookId);
            if (hookId && hook) {
                const hookTriggerFields = await ncMeta.metaList2(hook.fk_workspace_id, hook.base_id, _globals.MetaTable.HOOK_TRIGGER_FIELDS, {
                    condition: {
                        fk_hook_id: hookId
                    }
                });
                hook.trigger_fields = hookTriggerFields.map((field)=>field.fk_column_id);
            }
            await _NocoCache.default.set(context, `${_globals.CacheScope.HOOK}:${hookId}`, hook);
        }
        return hook && new Hook(hook);
    }
    async getFilters(context, ncMeta = _Noco.default.ncMeta) {
        return await _Filter.default.rootFilterListByHook(context, {
            hookId: this.id
        }, ncMeta);
    }
    static async list(context, param, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.HOOK, [
            param.fk_model_id
        ]);
        let { list: hooks } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !hooks.length) {
            hooks = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.HOOKS, {
                condition: {
                    fk_model_id: param.fk_model_id
                },
                orderBy: {
                    created_at: 'asc'
                }
            });
            if (hooks && hooks.length > 0) {
                const hookTriggerFields = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_TRIGGER_FIELDS, {
                    xcCondition: {
                        fk_hook_id: {
                            in: hooks.map((k)=>k.id)
                        }
                    }
                });
                for (const hook of hooks){
                    if (hook.version === 'v3' && hook.trigger_field) {
                        const triggerFields = hookTriggerFields.filter((k)=>k.fk_hook_id === hook.id).map((k)=>k.fk_column_id);
                        hook.trigger_fields = triggerFields;
                    }
                }
            }
            await _NocoCache.default.setList(context, _globals.CacheScope.HOOK, [
                param.fk_model_id
            ], hooks);
        }
        // filter event & operation
        if (param.event) {
            hooks = hooks.filter((h)=>{
                var _h_event, _param_event;
                return ((_h_event = h.event) == null ? void 0 : _h_event.toLowerCase()) === ((_param_event = param.event) == null ? void 0 : _param_event.toLowerCase());
            });
        }
        if (param.operation) {
            hooks = hooks.filter((h)=>{
                var _h_operation, _param_operation;
                return h.version === 'v3' ? (0, _webhookHelpers.compareOperationCode)({
                    code: h.operation,
                    operation: param.operation.replace('bulk', '').toLowerCase()
                }) : ((_h_operation = h.operation) == null ? void 0 : _h_operation.toLowerCase()) === ((_param_operation = param.operation) == null ? void 0 : _param_operation.toLowerCase());
            });
            if (param.operation === 'update' || param.operation === 'bulkUpdate') {
                hooks = hooks.filter((hook)=>{
                    var _hook_trigger_fields;
                    return !hook.trigger_field || ((_hook_trigger_fields = hook.trigger_fields) == null ? void 0 : _hook_trigger_fields.some((field)=>{
                        var _param_affectedColumns;
                        return (_param_affectedColumns = param.affectedColumns) == null ? void 0 : _param_affectedColumns.includes(field);
                    }));
                });
            }
        }
        return hooks == null ? void 0 : hooks.map((h)=>new Hook(h));
    }
    static async insert(context, hook, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(hook, [
            'fk_model_id',
            'title',
            'description',
            'env',
            'type',
            'event',
            'operation',
            'async',
            'url',
            'headers',
            'condition',
            'notification',
            'retries',
            'retry_interval',
            'timeout',
            'active',
            'base_id',
            'source_id',
            'trigger_field'
        ]);
        if (insertObj.notification && typeof insertObj.notification === 'object') {
            insertObj.notification = JSON.stringify(insertObj.notification);
        }
        const model = await _Model.default.getByIdOrName(context, {
            id: hook.fk_model_id
        }, ncMeta);
        if (!insertObj.source_id) {
            insertObj.source_id = model.source_id;
        }
        // new hook will set as version 3
        insertObj.version = 'v3';
        insertObj.operation = (0, _webhookHelpers.operationArrToCode)(insertObj.operation);
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.HOOKS, insertObj);
        if (hook.trigger_fields && hook.trigger_fields.length > 0) {
            await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_TRIGGER_FIELDS, hook.trigger_fields.map((colId)=>{
                return {
                    fk_hook_id: id,
                    fk_column_id: colId
                };
            }), true);
        }
        await _NocoCache.default.incrHashField('root', `${_globals.CacheScope.RESOURCE_STATS}:workspace:${context.workspace_id}`, _nocodbsdk.PlanLimitTypes.LIMIT_WEBHOOK_PER_WORKSPACE, 1);
        return this.get(context, id, ncMeta).then(async (hook)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.HOOK, [
                hook.fk_model_id
            ], `${_globals.CacheScope.HOOK}:${id}`);
            return hook;
        });
    }
    // temporary
    // TODO: remove after v2 has been sunsetted
    static async insertV2(context, hook, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(hook, [
            'fk_model_id',
            'title',
            'description',
            'env',
            'type',
            'event',
            'operation',
            'async',
            'url',
            'headers',
            'condition',
            'notification',
            'retries',
            'retry_interval',
            'timeout',
            'active',
            'base_id',
            'version',
            'source_id',
            'trigger_field'
        ]);
        if (insertObj.notification && typeof insertObj.notification === 'object') {
            insertObj.notification = JSON.stringify(insertObj.notification);
        }
        const model = await _Model.default.getByIdOrName(context, {
            id: hook.fk_model_id
        }, ncMeta);
        if (!insertObj.source_id) {
            insertObj.source_id = model.source_id;
        }
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.HOOKS, insertObj);
        if (hook.trigger_fields && hook.trigger_fields.length > 0) {
            await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_TRIGGER_FIELDS, hook.trigger_fields.map((colId)=>{
                return {
                    fk_hook_id: id,
                    fk_column_id: colId
                };
            }), true);
        }
        await _NocoCache.default.incrHashField('root', `${_globals.CacheScope.RESOURCE_STATS}:workspace:${context.workspace_id}`, _nocodbsdk.PlanLimitTypes.LIMIT_WEBHOOK_PER_WORKSPACE, 1);
        return this.get(context, id, ncMeta).then(async (hook)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.HOOK, [
                hook.fk_model_id
            ], `${_globals.CacheScope.HOOK}:${id}`);
            return hook;
        });
    }
    static async update(context, hookId, hook, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(hook, [
            'title',
            'description',
            'env',
            'type',
            'event',
            'operation',
            'async',
            'payload',
            'url',
            'headers',
            'condition',
            'notification',
            'retries',
            'retry_interval',
            'timeout',
            'active',
            'version',
            'trigger_field'
        ]);
        if (updateObj.version && updateObj.operation && updateObj.version === 'v1' && [
            'bulkInsert',
            'bulkUpdate',
            'bulkDelete'
        ].includes(updateObj.operation)) {
            _catchError.NcError.badRequest(`${updateObj.operation} not supported in v1 hook`);
        }
        if (updateObj.notification && typeof updateObj.notification === 'object') {
            updateObj.notification = JSON.stringify(updateObj.notification);
        }
        // [DEPRECATED]: should not need to check for v3
        if (updateObj.version === 'v3') {
            updateObj.operation = (0, _webhookHelpers.operationArrToCode)(updateObj.operation);
        }
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.HOOKS, updateObj, hookId);
        // [DEPRECATED]: should not need to check for v3
        if (updateObj.version === 'v3') {
            await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_TRIGGER_FIELDS, {
                fk_hook_id: hookId
            });
            await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_TRIGGER_FIELDS, (hook.trigger_fields || []).map((colId)=>{
                return {
                    fk_hook_id: hookId,
                    fk_column_id: colId
                };
            }), true);
            updateObj.trigger_fields = hook.trigger_fields;
        }
        await _NocoCache.default.update(context, `${_globals.CacheScope.HOOK}:${hookId}`, updateObj);
        return this.get(context, hookId, ncMeta);
    }
    static async delete(context, hookId, ncMeta = _Noco.default.ncMeta) {
        // Delete Hook Filters
        const filterList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
            condition: {
                fk_hook_id: hookId
            }
        });
        for (const filter of filterList){
            await _NocoCache.default.deepDel(context, `${_globals.CacheScope.FILTER_EXP}:${filter.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            await _HookFilter.default.delete(context, filter.id, ncMeta);
        }
        // Delete Hook
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.HOOK}:${hookId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        await _NocoCache.default.incrHashField('root', `${_globals.CacheScope.RESOURCE_STATS}:workspace:${context.workspace_id}`, _nocodbsdk.PlanLimitTypes.LIMIT_WEBHOOK_PER_WORKSPACE, -1);
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_TRIGGER_FIELDS, {
            fk_hook_id: hookId
        });
        return await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.HOOKS, hookId);
    }
    static async hookUsages(context, hookId, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_BUTTON, {
            condition: {
                fk_webhook_id: hookId
            }
        });
    }
    static async deleteTriggersByColumnId(context, columnId, ncMeta = _Noco.default.ncMeta) {
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.HOOK_TRIGGER_FIELDS, {
            fk_column_id: columnId
        });
    }
    constructor(hook){
        Object.assign(this, hook);
        if (hook.version === 'v3' && typeof hook.operation === 'string') {
            this.operation = (0, _webhookHelpers.operationCodeToArr)(hook.operation);
        }
    }
};
